import getLogger from "../../logger/index";
import { config } from "api/config";
import { get } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";

const log = getLogger("SEARCHUDH_REQUEST");
export const SEARCHUDHOFFICEAGENTS_REQUEST = "SEARCHUDHOFFICEAGENTS_REQUEST";
export const SEARCHUDHOFFICEAGENTS_SUCCESS = "SEARCHUDHOFFICEAGENTS_SUCCESS";
export const SEARCHUDHOFFICEAGENTS_FAILURE = "SEARCHUDHOFFICEAGENTS_FAILURE";
export const SET_SEARCHUDHOFFICEAGENTS_DATA = "SET_SEARCHUDHOFFICEAGENTS_DATA";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";
export function searchUDHOfficeAgentsRequest() {
  return {
    type: SEARCHUDHOFFICEAGENTS_REQUEST,
    status: REQUESTING,
  };
}
export function searchUDHOfficeAgentsSuccess(agents) {
  return {
    type: SEARCHUDHOFFICEAGENTS_SUCCESS,
    status: SUCCESS,
    agents,
  };
}
export function searchUDHOfficeAgentsFailure(error) {
  return {
    type: SEARCHUDHOFFICEAGENTS_FAILURE,
    status: ERROR,
    error,
  };
}
export function setSearchUDHOfficeAgentsData(searchData) {
  return {
    type: SET_SEARCHUDHOFFICEAGENTS_DATA,
    searchData,
  };
}

export function searchUDHOfficeAgents(fulfillment_id) {
  return async (dispatch) => {
    dispatch(searchUDHOfficeAgentsRequest());
    try {
      const result = await get(
        `${
          config.GATEWAY_URL
        }/${getDynamicRoute()}/api/v3/udh/officeAgents?fulfillment_id=${fulfillment_id}`,
        5000,
      );

      const resultJson = result;
      const agents =
        resultJson && resultJson.data && resultJson.data.data && resultJson.data.data.agents
          ? resultJson.data.data.agents
          : [];

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }

      return dispatch(searchUDHOfficeAgentsSuccess(agents));
    } catch (e) {
      log.error(
        "Error while fetching SEARCHUDHOFFICEAGENTS_REQUEST data - fulfillment_id : " +
          fulfillment_id,
        e,
      );
      dispatch(searchUDHOfficeAgentsFailure(e.message));
    }
  };
}
